module.exports = __webpack_public_path__ + "img/IMG_9458_59_60_L_Black_MockedUp.0e1dd846.jpg";